import { render, staticRenderFns } from "./FunnelSettings.vue?vue&type=template&id=0aab9b5e&scoped=true&lang=pug&"
import script from "./FunnelSettings.vue?vue&type=script&lang=js&"
export * from "./FunnelSettings.vue?vue&type=script&lang=js&"
import style0 from "./FunnelSettings.vue?vue&type=style&index=0&id=0aab9b5e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aab9b5e",
  null
  
)

export default component.exports